<template>
  <md-tabs class="_sidebar__tabGroup" md-alignment="centered" :md-active-tab="activeTabId" @md-changed="tabChanged">
    <template slot="md-tab" slot-scope="{ tab }">
      <span class="md-tab-button-card" v-if="tab.data.title" :title="tab.data.isDisabled ? tab.data.title : ''">
        <md-icon class="md-tab-icon">{{ tab.icon }}</md-icon>
        <span class="md-tab-label">{{ tab.label }}</span>
      </span>
      <span class="md-tab-button-card" v-if="!tab.data.title">
        <md-icon class="md-tab-icon">{{ tab.icon }}</md-icon>
        <span class="md-tab-label">{{ tab.label }}</span>
        <!-- Count Bubble on Sidepanel tab -->
        <i class="badge" v-if="tab.data.badge">{{ tab.data.badge }}</i>
      </span>
    </template>
    <md-tab 
      class="_sidebar__tabItem" 
      v-for="_tab in tabs"
      :key="_tab.id"
      :id="_tab.id"
      :md-label="_tab.label"
      :md-icon="_tab.icon"
      :md-disabled="_tab.isDisabled"
      :md-template-data="_tab.badge ? { title: _tab.title, isDisabled: _tab.isDisabled, badge: _tab.badge } : { title: _tab.title, isDisabled: _tab.isDisabled }"
    >
      <portal-target :name="`sidepanel-portal-${_tab.id}`" />
    </md-tab>
  </md-tabs>
</template>

<script>
export default {
  name: 'side-panel-tabs',
  props: {
    tabs: {
      type: Array,
      required: false,
    },
    activeTabId: {
      type: String,
      required: false,
    },
  },
  methods: {
    tabChanged (tabId) {
      window.$bus.$emit("side-bar-tab-changed", tabId)        
    },
  },
  mounted() {
    window.$bus.$on("badge-changed", (tabId, badge) => {
      let tabsNew = this.tabs
      tabsNew.map((tab) => {
        if (tab.id === tabId) {
          let newTab = tab
          newTab.badge = badge
          return newTab
        }
        return tab;
      });
      this.$emit('update:tabs', tabsNew)
    })
  }
}
</script>

<style lang="scss" scoped>
  .md-button:not(.md-just-icon) .md-button-content i {
    font-size: 10px !important;
  }
  .badge {
    width: 19px;
    height: 22px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 2px;
    right: 2px;
    background: #3E5877;
    border-radius: 100%;
    color: #fff;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -.05em;
    font-family: 'Roboto Mono', monospace;
  }
</style>
